import { combineReducers } from 'redux';
import allowListReducer from './allowList/allowList.reducer';

export default combineReducers({
  allowList: allowListReducer
});
